<template>
  <tr>
    <th colspan="2" class="text-center">Summary</th>
    <th></th>
    <th></th>
    <th class="text-center">
      <div>
        {{ totalProductPrice + " ฿" }}
      </div>
    </th>
    <th class="text-center">
      <div>
        {{ totalDiscountPrice + " ฿" }}
      </div>
    </th>
    <th class="text-center">
      <div>
        {{ totalNetPrice + " ฿" }}
      </div>
    </th>
    <th></th>
  </tr>
</template>

<script>
export default {
  name: "summaryReport",
  props: ["reportList"],
  computed: {
    totalProductPrice() {
      if (this.reportList.length === 0) {
        return 0;
      } else {
        const val = this.reportList.order.reduce((total, order) => {
          return total + order.order_total_product_price;
        }, 0);
        return val;
      }
    },
    totalDiscountPrice() {
      if (this.reportList.length === 0) {
        return 0;
      } else {
        const val = this.reportList.order.reduce((total, order) => {
          return total + order.order_total_discount_price;
        }, 0);
        return val;
      }
    },
    totalNetPrice() {
      if (this.reportList.length === 0) {
        return 0;
      } else {
        const val = this.reportList.order.reduce((total, order) => {
          return total + order.order_total_net_price;
        }, 0);
        return val;
      }
    },
  },
};
</script>

<style>
</style>